import { useSelector } from "react-redux";
import {
  master,
  useGetDepartmentListDataQuery,
  // useGetDepartmentSelectDataQuery,
  useUpdateDepartmentTableHeadDataMutation,
} from "../../../store/queries/Master";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { updateConfig } from "../../../store/slices/Master/Department/departmentSlice";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  approveDepartmentRequest,
  deleteDepartment,
  getDepartmentData,
} from "./api";
import { Button } from "@wac-ui-dashboard/wac_component_library";

const useDepartment = () => {
  let paginationOptions = [
    { label: "20 Per page", value: 20 },
    { label: "40 Per page", value: 40 },
    { label: "60 Per page", value: 60 },
  ];

  const dispatch = useDispatch();

  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const departmentState = useSelector((state) => state.department);
  const {
    data: departmentList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetDepartmentListDataQuery({
    page_size: departmentState.currentPageSize,
    page: departmentState.currentPage,
    sort_by: departmentState.sortBy,
    sort_order: departmentState.sortOrder,
    start: departmentState.startDate,
    end: departmentState.endDate,
    search: departmentState.search,
  });

  const [updateDepartmentFields] = useUpdateDepartmentTableHeadDataMutation();

  useEffect(() => {
    dispatch(
      globalUpdateConfig((state) => {
        state.tableFields = departmentList?.data?.fields;
      })
    );
    // eslint-disable-next-line
  }, [departmentList]);

  useEffect(() => {
    if (departmentState?.selectedDepartment && departmentState?.isEdit) {
      fillDepartmentData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departmentState?.isEdit, departmentState?.showAddDepartmentModal]);
  useEffect(() => {
    if (departmentState.clearSelection) {
      dispatch(
        updateConfig((state) => {
          state.clearSelection = false;
        })
      );
    }
    // eslint-disable-next-line
  }, [departmentState.clearSelection]);

  const handleModalClick = () => {
    dispatch(
      updateConfig((state) => {
        state.showAddDepartmentModal = !state.showAddDepartmentModal;
        state.isEdit = false;
      })
    );
  };

  const getRow = (feild, data) => {
    const rows = {
      common: (feild, data) => <p className="pro-mb-0">{data[feild]}</p>,
      status: (field, data) =>
        data?.status === "Pending" &&
        departmentList?.data?.approve_permission ? (
          <Button
            className={"pro-btn-primary sm"}
            type="button"
            onClick={() => handleApprovePermission(data?._id)}
          >
            {"Approve"}
          </Button>
        ) : data?.status === "Deleted" ? (
          <span className={"pro-badge badge-danger-outline"}>{"Deleted"}</span>
        ) : data?.status === "Active" ? (
          <span className={"pro-badge badge-success-outline"}>{"Active"}</span>
        ) : (
          data?.status
        ),
    };

    return rows?.[feild]?.(feild, data) ?? rows["common"](feild, data);
  };
  const handleApprovePermission = (approveId) => {
    let params = {
      departments_id: approveId,
    };
    approveDepartmentRequest(params).then((response) => {
      if (response?.data?.status_code === 200) {
        refetch();
        toast.success("Approved successfully");
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  const handleDelete = () => {
    let data = {
      department_id: departmentState?.selectedDepartment,
    };
    deleteDepartment(data).then((response) => {
      if (response?.data?.status_code === 200) {
        toast.success("Department deleted successfully");
        handleDeleteModal();
        refetch();
        dispatch(master.util.invalidateTags(["DepartmentListData"]))
      } else {
        toast.error("Something went wrong");
        handleDeleteModal();
      }
    });
  };

  const fillDepartmentData = () => {
    getDepartmentData(departmentState?.selectedDepartment).then((response) => {
      if (response?.data?.status_code === 200) {
        dispatch(
          updateConfig((state) => (state.itemData = response?.data?.data))
        );
      } else {
        toast.error("Something went wrong to fetch data");
      }
    });
  };

  const handleDeleteModal = (e) => {
    dispatch(
      updateConfig((state) => {
        state.showDeleteModal = !state.showDeleteModal;
        state.selectedDepartment = e?.[0];
      })
    );
    dispatch(master.util.invalidateTags(["DepartmentListData"]))
  };

  const handleEditAction = (e) => {
      // dispatch(master.util.invalidateTags(["Department"]))
    dispatch(
      updateConfig((state) => {
        state.showAddDepartmentModal = true;
        state.selectedDepartment = e?.[0];
        state.isEdit = true;
      })
    );
  };

  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e.target.value;
        state.currentPage = 1;
      })
    );
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
    dispatch(master.util.invalidateTags(["DepartmentListData"]))
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handleSort = (label) => {
    if (departmentState.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            departmentState.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };
  return {
    departmentState,
    showEditModal,
    tableFields,
    departmentList,
    isLoading,
    isFetching,
    paginationOptions,
    getRow,
    handleEditColumnsClick,
    handleSort,
    handlePagination,
    handleModalClick,
    handleDelete,
    handleDeleteModal,
    handleEditAction,
    handleSearch,
    updateDepartmentFields,
    handleClearClick,
    handlePageSize,
    refetch,
  };
};

export default useDepartment;
